export default {
    active: 'Active',
    inactive: 'Inactive'
}
